/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Summary_Integration_Past_3Inputs */



/**
* | output |
* | --- |
* | "reached into your tools" |
*
* @param {Chat_Summary_Integration_Past_3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_summary_integration_past_3 = /** @type {((inputs?: Chat_Summary_Integration_Past_3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Summary_Integration_Past_3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("auf deine Tools zugegriffen")
	return /** @type {LocalizedString} */ ("reached into your tools")
});